import util from '@bmp-vue/core/api/util'

const controller = 'PersistedGrants'
export default Object.assign({}, util.GetCrud(controller, null))
